unit UAttachmentListForm;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls, UMainConfig,
  Vcl.Imaging.pngimage, Vcl.Controls, WEBLib.ExtCtrls, WEBLib.Buttons,
  UAttachmentList, Types, Vcl.Grids, WEBLib.Grids, System.NetEncoding,
  WEBLib.WebCtrls, WEBLib.LocalFiles, UEssentialHelper, Vcl.Menus, WEBLib.Menus,
  UAttachmentModel, UContentList;

const
  COLUMNWIDTH = 150;

type
  TAttachmentListForm = class(TForm)
    pnlHeader: TPanel;
    imgLogo: TImageControl;
    lblHeader: TLabel;
    btnBack: TImageControl;
    pnlFooter: TPanel;
    pnlButtons: TPanel;
    btnWebCam: TBitBtn;
    pnlAttachmentList: TPanel;
    btnFilesystem: TBitBtn;
    btnComment: TBitBtn;
    lbl: TLabel;
    sgAttachmentList: TStringGrid;
    pnlSmallButtons: TPanel;
    btnEdit: TBitBtn;
    btnDelete: TBitBtn;
    btnLoad: TBitBtn;
    pnlInfo: TPanel;
    lblInfo: TLabel;
    btnTake: TBitBtn;
    procedure WebFormResize(Sender: TObject);
    procedure btnBackClick(Sender: TObject);
    [Async]
    procedure btnWebCamClick(Sender: TObject); async;
    procedure WebFormCreate(Sender: TObject);
    procedure btnFilesystemClick(Sender: TObject);
    [Async]
    procedure btnCommentClick(Sender: TObject); async;
    [Async]
    procedure sgAttachmentListDblClick(Sender: TObject); async;
    procedure sgAttachmentListSelectCell(Sender: TObject; ACol, ARow: Integer;
      var CanSelect: Boolean);
    [Async]
    procedure btnEditClick(Sender: TObject); async;
    procedure btnDeleteClick(Sender: TObject);
    procedure btnLoadClick(Sender: TObject);
    procedure sgAttachmentListClickCell(Sender: TObject; ACol, ARow: Integer);
    procedure btnTakeClick(Sender: TObject);
    procedure WebFormOrientationChange(Sender: TObject;
      AOrientation: TScreenOrientation);
  private
    FMainConfig: TMainConfig;
    FFakNr: String;
    FAttachmentList: TAttachmentList;
    FMaxCols: Integer;
    FSelectedItem: TAttachmentModel;
    FContentList: TContentList;
    FKind: TAttachmentKind;
    FWithFill: Boolean;
    procedure DeleteSelectedItem(Sender: TObject);
    procedure HandleError(Sender: TObject; AMsg: string);
    [Async]
    procedure HandleGetContent(Sender: TObject); async;
    procedure HandleSnapshot(Sender: TObject; Filename: string;
      Kind: TAttachmentKind);
    [Async]
    procedure SgAttachmentListFill(Sender: TObject); async;
    procedure SetMainConfig(const Value: TMainConfig);
    procedure SetFakNr(const Value: String);
    procedure SetAttachmentList(const Value: TAttachmentList);
    procedure SetSelectedItem(const Value: TAttachmentModel);
    procedure SetContentList(const Value: TContentList);
    procedure SetKind(const Value: TAttachmentKind);
  public
    procedure EnableButtons(Value: Boolean);
    property MainConfig: TMainConfig read FMainConfig write SetMainConfig;
    property FakNr: String read FFakNr write SetFakNr;
    property AttachmentList: TAttachmentList read FAttachmentList
      write SetAttachmentList;
    property SelectedItem: TAttachmentModel read FSelectedItem
      write SetSelectedItem;
    property ContentList: TContentList read FContentList write SetContentList;
    property Kind: TAttachmentKind read FKind write SetKind;
  protected procedure LoadDFMValues; override; end;

var
  AttachmentListForm: TAttachmentListForm;

implementation

uses
  UCameraForm, WEBLib.Storage, Math, WEBLib.Utils, UCommentForm, UImageShowForm,
  UTransferModel;

{$R *.dfm}
{ TPictureListForm }

procedure TAttachmentListForm.btnBackClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  Self.ModalResult := mrNone;
  Self.Close;
end;

procedure TAttachmentListForm.btnCommentClick(Sender: TObject);
var
  frm: TCommentForm;
begin
  Self.MainConfig.TimerReset;
  if Self.FakNr <> '' then
  begin
    frm := TCommentForm.Create(Self);
    frm.Caption := Self.Caption;
    frm.Popup := false;
    await(TCommentForm, frm.Load);
    frm.FakNr := Self.FakNr;
    frm.Filename := '';
    frm.OnTakeComment := Self.HandleSnapshot;
    frm.MainConfig := Self.MainConfig;
    try
      Self.Hide;
      await(TModalResult, frm.Execute);
    finally
      frm.Free;
      Self.Show;
      Self.WebFormResize(Sender);
    end;
  end;
end;

procedure TAttachmentListForm.btnDeleteClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  Self.DeleteSelectedItem(Self.SelectedItem);
end;

procedure TAttachmentListForm.btnEditClick(Sender: TObject);
var
  frm: TCommentForm;
begin
  Self.MainConfig.TimerReset;
  if (Self.SelectedItem <> nil) and (Self.SelectedItem.Kind = akComment) and
    (Self.SelectedItem.TransmittedAt = 0) then
  begin
    frm := TCommentForm.Create(Self);
    frm.Caption := Self.Caption;
    frm.Popup := false;
    await(TCommentForm, frm.Load);
    frm.FakNr := Self.SelectedItem.FakNr;
    frm.Filename := Self.SelectedItem.Filename;
    frm.pnlButtons.Visible := true;
    frm.MainConfig := Self.MainConfig;
    try
      Self.Hide;
      await(TModalResult, frm.Execute);
    finally
      frm.Free;
      Self.Show;
      Self.WebFormResize(Sender);
    end;
  end;
end;

procedure TAttachmentListForm.btnFilesystemClick(Sender: TObject);
var
  bFile: TBinaryFile;
  procedure HandleFileOpen(Sender: TObject);
  var
    f: TBinaryFile;
    t: TTextFile;
    s: string;
    procedure HandleFileSave(Sender: TObject);
    var
      t1: TTextFile;
    begin
      if Sender is TTextFile then
      begin
        t1 := Sender as TTextFile;
        Self.HandleSnapshot(Sender, t1.Filename, akPicture);
      end;
    end;

  begin
    if Sender is TBinaryFile then
    begin
      f := Sender as TBinaryFile;
      s := ArrayBufferToBase64(f.Data);
      s := 'data:image/png;base64,' + s;
      t := TTextFile.Create(nil);
      t.OnFileSave := HandleFileSave;
      t.Text := s;
      t.SaveAsFile(Self.FFakNr + '\Pictures', f.Filename);
    end;
  end;

begin
  Self.MainConfig.TimerReset;
  if Self.FakNr <> '' then
  begin
    bFile := TBinaryFile.Create(nil);
    bFile.Filter.Add('PNG-Dateien', 'image/png', '*.png');
    bFile.Filter.Add('JPEG-Dateien', 'image/jpeg', '*.jpeg');
    bFile.Filter.Add('JPG-Dateien', 'image/jpg', '*.jpg');
    bFile.Filter.Add('Alle Dateien', '', '*.*');
    bFile.OnFileOpen := HandleFileOpen;
    bFile.OpenFile;
  end;
end;

procedure TAttachmentListForm.btnLoadClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  Self.ContentList.Clear;
  Self.ContentList.GetContent(Self.MainConfig.Uri, Self.FakNr);
end;

procedure TAttachmentListForm.btnTakeClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  Self.ModalResult := mrOk;
  Self.Close;
end;

procedure TAttachmentListForm.btnWebCamClick(Sender: TObject);
var
  frm: TCameraForm;
begin
  Self.MainConfig.TimerReset;
  if Self.FakNr <> '' then
  begin
    frm := TCameraForm.Create(Self);
    frm.Caption := Self.Caption;
    frm.Popup := false;
    await(TCameraForm, frm.Load);
    frm.FakNr := Self.FakNr;
    frm.OnSnapshot := Self.HandleSnapshot;
    frm.MainConfig := Self.MainConfig;
    try
      Self.Hide;
      await(TModalResult, frm.Execute);
    finally
      frm.Free;
      Self.Show;
      Self.WebFormResize(Sender);
    end;
  end;
end;

procedure TAttachmentListForm.DeleteSelectedItem(Sender: TObject);
var
  i: Integer;
  s: string;
  procedure HandleDeleteSelectedItem(Result: TModalResult);
  var
    path, fname: string;
    tFile: TTextFile;
  begin
    if Result = mrYes then
    begin
      path := Self.SelectedItem.FakNr;
      fname := Self.SelectedItem.Filename;
      case Self.SelectedItem.Kind of
        akUnknown:
          path := '';
        akPicture:
          path := path + '\Pictures';
        akComment:
          path := path + '\Comments';
      end;
      Self.AttachmentList.Delete(i);
      tFile := TTextFile.Create(Self);
      tFile.DeleteFile(path, fname);
      Self.SelectedItem := nil;
    end;
  end;

begin
  if Self.SelectedItem <> nil then
  begin
    i := Self.AttachmentList.IndexOf(Self.SelectedItem);
    if i >= 0 then
    begin
      s := 'Möchten Sie den Anhang' + #13#10;
      case Self.SelectedItem.Kind of
        akUnknown:
          ;
        akPicture:
          s := s + 'Typ: Bild' + #13#10;
        akComment:
          s := s + 'Typ: Notiz' + #13#10;
      end;
      s := s + 'Dateiname: ' + Self.SelectedItem.Filename + #13#10;
      s := s + 'jetzt löschen?';
      MessageDLG(s, mtConfirmation, [mbYes, mbNo], @HandleDeleteSelectedItem);
    end;
  end;
end;

procedure TAttachmentListForm.HandleError(Sender: TObject; AMsg: string);
begin
  MessageDLG(AMsg, mtError, [mbOK], nil);
  if Sender is TAttachmentModel then
  begin
    Self.ContentList.Delete(Self.ContentList.Count - 1);
    Self.HandleGetContent(Self.ContentList);
  end;
end;

procedure TAttachmentListForm.HandleGetContent(Sender: TObject);
var
  i: Integer;
  cItem: TContentModel;
  aItem: TAttachmentModel;
  t: TTextFile;
  dummy: TCallback;
  procedure HandleGetData(Sender: TObject);
  var
    cModel: TContentModel;
    aModel: TAttachmentModel;
  begin
    if Sender is TContentModel then
    begin
      cModel := Sender as TContentModel;
      aModel := TAttachmentModel.Create;
      aModel.FakNr := cModel.FakNr;
      aModel.Filename := cModel.Filename;
      aModel.CreatedAt := cModel.Created;
      aModel.Kind := cModel.Kind;
      aModel.TransmittedAt := cModel.Received;
      aModel.Name := cModel.Name;
      aModel.Vorname := cModel.Vorname;
      Self.AttachmentList.Add(aModel);
    end;
  end;

[Async]
  procedure HandleFileExists(Sender: TObject; AValue: Boolean); async;
  begin
    if not AValue then
    begin
      cItem.OnGetData := HandleGetData;
      cItem.OnError := Self.HandleError;
      await(cItem.GetData(Self.MainConfig.Uri));
    end;
  end;

begin
  if Sender is TContentList then
  begin
    Self.ContentList := Sender as TContentList;
    dummy := Self.AttachmentList.OnListChanged;
    Self.AttachmentList.OnListChanged := nil;
    for i := 0 to Self.ContentList.Count - 1 do
    begin
      cItem := Self.ContentList.Items[i];
      if cItem.Kind in [akPicture, akComment] then
      begin
        aItem := Self.AttachmentList.GetByKindAndFilename(cItem.Kind,
          cItem.Filename);
        if aItem = nil then
        begin
          cItem.OnGetData := HandleGetData;
          cItem.OnError := Self.HandleError;
          await(cItem.GetData(Self.MainConfig.Uri));
        end
        else
        begin
          t := TTextFile.Create(nil);
          t.OnFileExists := HandleFileExists;
          case cItem.Kind of
            akUnknown, akPdf:
              ;
            akPicture:
              await(t.FileExists(Self.FFakNr + '\Pictures', cItem.Filename));
            akComment:
              await(t.FileExists(Self.FFakNr + '\Comments', cItem.Filename));
          end;
        end;
      end;
    end;
    Self.AttachmentList.OnListChanged := dummy;
    Self.SgAttachmentListFill(nil);
  end;
end;

procedure TAttachmentListForm.HandleSnapshot(Sender: TObject; Filename: string;
  Kind: TAttachmentKind);
var
  item: TAttachmentModel;
begin
  item := TAttachmentModel.Create;
  item.FakNr := Self.FakNr;
  item.Filename := Filename;
  item.Kind := Kind;
  item.PersonalNr := Self.MainConfig.User.PersonalNr;
  item.Name := Self.MainConfig.User.Name;
  item.Vorname := Self.MainConfig.User.Vorname;
  Self.AttachmentList.Add(item);
end;

procedure TAttachmentListForm.SetAttachmentList(const Value: TAttachmentList);
begin
  FAttachmentList := Value;
end;

procedure TAttachmentListForm.SetContentList(const Value: TContentList);
begin
  FContentList := Value;
end;

procedure TAttachmentListForm.SetKind(const Value: TAttachmentKind);
begin
  FKind := Value;
  btnTake.Visible := Self.Kind <> akUnknown;
end;

procedure TAttachmentListForm.SetFakNr(const Value: String);
begin
  if FFakNr <> Value then
  begin
    FFakNr := Value;
    Self.AttachmentList := TAttachmentList.Create;
    Self.AttachmentList.FakNr := Self.FakNr;
    Self.AttachmentList.PersonalNr := Self.MainConfig.User.PersonalNr;
    Self.AttachmentList.Kind := Self.Kind;
    Self.AttachmentList.OnListChanged := Self.SgAttachmentListFill;
    Self.AttachmentList.Load;
  end;
end;

procedure TAttachmentListForm.SetMainConfig(const Value: TMainConfig);
begin
  FMainConfig := Value;
  Self.MainConfig.CurrentForm := Self.Name;
  ColorComponents(Self, Self.MainConfig.ColorConfig);
  pnlFooter.Caption := Self.MainConfig.Copyright;
  Self.WebFormResize(Self);
end;

procedure TAttachmentListForm.SetSelectedItem(const Value: TAttachmentModel);
begin
  pnlSmallButtons.Visible := false;
  FSelectedItem := Value;
  if (Self.SelectedItem <> nil) and (Self.SelectedItem.TransmittedAt = 0) then
  begin
    pnlSmallButtons.Visible := true;
    btnEdit.Visible := Self.SelectedItem.Kind = akComment;
  end;
  if Self.SelectedItem <> nil then
  begin
    pnlInfo.Visible := true;
    if Self.SelectedItem.Vorname <> '' then
      lblInfo.Caption := 'Erstellt von ' + Self.SelectedItem.Vorname + ' ' +
        Self.SelectedItem.Name + ' am ' + FormatDateTime('ddd dd.mm.yyyy hh:nn',
        Self.SelectedItem.CreatedAt)
    else
      lblInfo.Caption := 'Erstellt von ' + Self.SelectedItem.Name + ' am ' +
        FormatDateTime('ddd dd.mm.yyyy hh:nn', Self.SelectedItem.CreatedAt);
  end
  else
    pnlInfo.Visible := false;
end;

procedure TAttachmentListForm.sgAttachmentListClickCell(Sender: TObject;
  ACol, ARow: Integer);
var
  r, c, i: Integer;
begin
  if (Self.Kind <> akUnknown) and (ARow >= 0) and (ACol >= 0) then
  begin
    r := ARow;
    c := ACol;
    lbl.Caption := 'r=' + IntToStr(r) + ', c=' + IntToStr(c);
    if r mod 2 = 1 then
      Dec(r);
    if c mod 2 = 1 then
      Dec(c);
    r := r div 2;
    c := c div 2;
    i := (r * FMaxCols) + c;
    lbl.Caption := lbl.Caption + ', i=' + IntToStr(i);
    if i < Self.AttachmentList.Count then
      Self.AttachmentList.Items[i].Selected := not Self.AttachmentList.Items
        [i].Selected;
  end;
end;

procedure TAttachmentListForm.sgAttachmentListDblClick(Sender: TObject);
var
  frm: TImageShowForm;
  frm1: TCommentForm;
begin
  if (Self.SelectedItem <> nil) then
  begin
    case Self.SelectedItem.Kind of
      akUnknown:
        ;
      akPicture:
        begin
          frm := TImageShowForm.Create(Self);
          frm.Caption := Self.Caption;
          frm.Popup := false;
          await(TImageShowForm, frm.Load);
          frm.MainConfig := Self.MainConfig;
          frm.Attachment := Self.SelectedItem;
          try
            Self.Hide;
            await(TModalResult, frm.Execute);
          finally
            frm.Free;
            Self.Show;
            Self.WebFormResize(Sender);
          end;
        end;
      akComment:
        begin
          frm1 := TCommentForm.Create(Self);
          frm1.Caption := Self.Caption;
          frm1.Popup := false;
          await(TCommentForm, frm1.Load);
          frm1.FakNr := Self.SelectedItem.FakNr;
          frm1.Filename := Self.SelectedItem.Filename;
          frm1.pnlButtons.Visible := false;
          frm1.MainConfig := Self.MainConfig;
          try
            Self.Hide;
            await(TModalResult, frm1.Execute);
          finally
            frm1.Free;
            Self.Show;
            Self.WebFormResize(Sender);
          end;
        end;
    end;
  end;
end;

procedure TAttachmentListForm.SgAttachmentListFill(Sender: TObject);
var
  rows, cols, i, j, r, c, Count, defWidth, defHeight: Integer;
  item: TAttachmentModel;
  tFile: TTextFile;
  procedure HandleFileOpen(Sender: TObject);
  var
    f: TTextFile;
    s: string;
    w, h: Integer;
  begin
    if Sender is TTextFile then
    begin
      f := Sender as TTextFile;
      s := f.Text;
      w := COLUMNWIDTH;
      h := (COLUMNWIDTH * 3) div 4;
      w := w - 4;
      h := h - 6;
      s := '<img src="' + s + '";  style="width:' + IntToStr(w) + 'px;height:' +
        IntToStr(h) + 'px;object-fit:cover;padding-top:2px;padding-right:2px;' +
        'padding-bottom:2px;padding-left:2px;" >';
      sgAttachmentList.Cells[f.Col, f.Row] := s;
    end;
  end;

  procedure HandleFileOpenComment(Sender: TObject);
  var
    f: TTextFile;
    s: string;
  begin
    if Sender is TTextFile then
    begin
      f := Sender as TTextFile;
      s := f.Text;
      sgAttachmentList.Cells[f.Col, f.Row] := s; // AlignTop(s);
    end;
  end;

begin
  FMaxCols := sgAttachmentList.ClientWidth div (COLUMNWIDTH + 24);
  if Self.AttachmentList <> nil then
    Count := Self.AttachmentList.Count
  else
    Count := 0;
  if Count > 0 then
    rows := ((Count - 1) div FMaxCols) + 1
  else
    rows := 1;
  if rows > 1 then
    cols := FMaxCols
  else
    cols := Max(1, Count);
  rows := rows * 2;
  cols := cols * 2;
  defHeight := (COLUMNWIDTH * 3) div 4;
  defWidth := COLUMNWIDTH;
  sgAttachmentList.ColCount := cols;
  sgAttachmentList.RowCount := rows;
  sgAttachmentList.FixedCols := 0;
  sgAttachmentList.FixedRows := 0;
  for i := 0 to rows - 1 do
    for j := 0 to cols - 1 do
      sgAttachmentList.Cells[j, i] := '';
  for i := 0 to Count - 1 do
  begin
    r := i div FMaxCols;
    c := i mod FMaxCols;
    r := r * 2;
    c := c * 2;
    item := Self.AttachmentList.Items[i];
    case item.Kind of
      akUnknown:
        ;
      akPicture:
        begin
          sgAttachmentList.ColWidths[c] := defWidth;
          sgAttachmentList.RowHeights[r] := defHeight;
          sgAttachmentList.ColWidths[c + 1] := 24;
          sgAttachmentList.RowHeights[r + 1] := 24;
          sgAttachmentList.Cells[c, r + 1] := '<div style="color: blue;">' +
            item.Filename + '</div>';
          if Self.Kind = akUnknown then
          begin
            if item.TransmittedAt > 0 then
              sgAttachmentList.Cells[c + 1, r + 1] :=
                '<img src="Images\IconOk.png" style="width:24px;height:24px;">';
          end
          else
          begin
            if item.Selected then
              sgAttachmentList.Cells[c + 1, r + 1] :=
                '<img src="Images\IconOk.png" style="width:24px;height:24px;">';
          end;
          tFile := TTextFile.Create(nil);
          tFile.OnFileOpen := HandleFileOpen;
          tFile.Row := r;
          tFile.Col := c;
          await(tFile.OpenFile(Self.FakNr + '\Pictures', item.Filename));
        end;
      akComment:
        begin
          sgAttachmentList.ColWidths[c] := defWidth;
          sgAttachmentList.RowHeights[r] := defHeight;
          sgAttachmentList.ColWidths[c + 1] := 24;
          sgAttachmentList.RowHeights[r + 1] := 24;
          sgAttachmentList.Cells[c, r + 1] := '<div style="color: blue;">' +
            item.Filename + '</div>';
          if Self.Kind = akUnknown then
          begin
            if item.TransmittedAt > 0 then
              sgAttachmentList.Cells[c + 1, r + 1] :=
                '<img src="Images\IconOk.png" style="width:24px;height:24px;">';
          end
          else
          begin
            if item.Selected then
              sgAttachmentList.Cells[c + 1, r + 1] :=
                '<img src="Images\IconOk.png" style="width:24px;height:24px;">';
          end;
          tFile := TTextFile.Create(nil);
          tFile.OnFileOpen := HandleFileOpenComment;
          tFile.Row := r;
          tFile.Col := c;
          await(tFile.OpenFile(Self.FakNr + '\Comments', item.Filename));
        end;
    end;
  end;
  if (Self.AttachmentList <> nil) and (Self.Kind <> akUnknown) then
  begin
    btnTake.Visible := Self.AttachmentList.AreItemsSelected;
    Self.FWithFill := false;
    Self.WebFormResize(Sender);
  end;
end;

procedure TAttachmentListForm.sgAttachmentListSelectCell(Sender: TObject;
  ACol, ARow: Integer; var CanSelect: Boolean);
var
  r, c, i: Integer;
begin
  if (Self.Kind = akUnknown) and (ARow >= 0) and (ACol >= 0) then
  begin
    r := ARow;
    c := ACol;
    lbl.Caption := 'r=' + IntToStr(r) + ', c=' + IntToStr(c);
    if r mod 2 = 1 then
      Dec(r);
    if c mod 2 = 1 then
      Dec(c);
    r := r div 2;
    c := c div 2;
    i := (r * FMaxCols) + c;
    lbl.Caption := lbl.Caption + ', i=' + IntToStr(i);
    if i < Self.AttachmentList.Count then
      Self.SelectedItem := Self.AttachmentList.Items[i]
    else
      Self.SelectedItem := nil;
  end;
end;

procedure TAttachmentListForm.WebFormCreate(Sender: TObject);
begin
  Self.FFakNr := '';
  Self.SelectedItem := nil;
  Self.FKind := akUnknown;
  Self.ContentList := TContentList.Create;
  Self.ContentList.OnError := Self.HandleError;
  Self.ContentList.OnLoaded := Self.HandleGetContent;
  Self.FWithFill := true;
end;

procedure TAttachmentListForm.WebFormOrientationChange(Sender: TObject;
  AOrientation: TScreenOrientation);
begin
  Self.WebFormResize(Sender);
end;

procedure TAttachmentListForm.WebFormResize(Sender: TObject);
begin
  if (Self.Height < 480) or (Self.Width < 640) then
  begin
    btnBack.Width := 24;
    btnBack.Height := 24;
    btnBack.Top := 4;
    btnBack.Left := 4;
    lblHeader.Font.Size := 10;
    lblHeader.Top := 7;
    imgLogo.Width := 74;
    imgLogo.Height := 24;
    imgLogo.Top := 4;
    pnlHeader.Height := 32;
    pnlFooter.Visible := false;
    lblHeader.Caption := 'Anhangliste';
    btnTake.Top := Self.ClientHeight - btnTake.Height - 48;
  end
  else
  begin
    btnBack.Width := 48;
    btnBack.Height := 48;
    btnBack.Top := 8;
    btnBack.Left := 8;
    lblHeader.Font.Size := 16;
    lblHeader.Top := 16;
    imgLogo.Width := 148;
    imgLogo.Height := 48;
    imgLogo.Top := 8;
    pnlHeader.Height := 64;
    pnlFooter.Visible := true;
    lblHeader.Caption := 'Winzeit - WebPortal - Anhangliste';
    btnTake.Top := Self.ClientHeight - (2 * pnlFooter.Height) -
      btnTake.Height - 48;
  end;
  pnlHeader.Width := Self.ClientWidth;
  pnlFooter.Width := pnlHeader.Width;
  lblHeader.Left := btnBack.Left + btnBack.Width + 8;
  lblHeader.Width := pnlHeader.ClientWidth - imgLogo.Width - 32;
  imgLogo.Left := pnlHeader.ClientWidth - imgLogo.Width - 16;
  btnLoad.Left := pnlButtons.ClientWidth - btnLoad.Width - 6;
  btnTake.Left := Self.ClientWidth - btnTake.Width - 24;
  if Self.FWithFill then
    Self.SgAttachmentListFill(Self)
  else
    Self.FWithFill := true;
end;

procedure TAttachmentListForm.EnableButtons(Value: Boolean);
begin
  btnWebCam.Visible := Value;
  btnFilesystem.Visible := Value;
  btnComment.Visible := Value;
end;

procedure TAttachmentListForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlHeader := TPanel.Create(Self);
  imgLogo := TImageControl.Create(Self);
  lblHeader := TLabel.Create(Self);
  btnBack := TImageControl.Create(Self);
  pnlFooter := TPanel.Create(Self);
  pnlButtons := TPanel.Create(Self);
  lbl := TLabel.Create(Self);
  btnWebCam := TBitBtn.Create(Self);
  btnFilesystem := TBitBtn.Create(Self);
  btnComment := TBitBtn.Create(Self);
  btnLoad := TBitBtn.Create(Self);
  pnlAttachmentList := TPanel.Create(Self);
  sgAttachmentList := TStringGrid.Create(Self);
  btnTake := TBitBtn.Create(Self);
  pnlSmallButtons := TPanel.Create(Self);
  btnEdit := TBitBtn.Create(Self);
  btnDelete := TBitBtn.Create(Self);
  pnlInfo := TPanel.Create(Self);
  lblInfo := TLabel.Create(Self);

  pnlHeader.BeforeLoadDFMValues;
  imgLogo.BeforeLoadDFMValues;
  lblHeader.BeforeLoadDFMValues;
  btnBack.BeforeLoadDFMValues;
  pnlFooter.BeforeLoadDFMValues;
  pnlButtons.BeforeLoadDFMValues;
  lbl.BeforeLoadDFMValues;
  btnWebCam.BeforeLoadDFMValues;
  btnFilesystem.BeforeLoadDFMValues;
  btnComment.BeforeLoadDFMValues;
  btnLoad.BeforeLoadDFMValues;
  pnlAttachmentList.BeforeLoadDFMValues;
  sgAttachmentList.BeforeLoadDFMValues;
  btnTake.BeforeLoadDFMValues;
  pnlSmallButtons.BeforeLoadDFMValues;
  btnEdit.BeforeLoadDFMValues;
  btnDelete.BeforeLoadDFMValues;
  pnlInfo.BeforeLoadDFMValues;
  lblInfo.BeforeLoadDFMValues;
  try
    Name := 'AttachmentListForm';
    Width := 640;
    Height := 480;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnOrientationChange', 'WebFormOrientationChange');
    SetEvent(Self, 'OnResize', 'WebFormResize');
    pnlHeader.SetParentComponent(Self);
    pnlHeader.Name := 'pnlHeader';
    pnlHeader.Left := 0;
    pnlHeader.Top := 0;
    pnlHeader.Width := 640;
    pnlHeader.Height := 64;
    pnlHeader.Align := alTop;
    pnlHeader.Caption := 'pnlHeader';
    pnlHeader.ChildOrder := 4;
    pnlHeader.Color := clSkyBlue;
    pnlHeader.ShowCaption := False;
    imgLogo.SetParentComponent(pnlHeader);
    imgLogo.Name := 'imgLogo';
    imgLogo.Left := 480;
    imgLogo.Top := 8;
    imgLogo.Width := 148;
    imgLogo.Height := 48;
    imgLogo.HeightPercent := 100.000000000000000000;
    imgLogo.WidthPercent := 100.000000000000000000;
    imgLogo.Picture.LoadFromFile('UAttachmentListForm.pnlHeader.imgLogo.Picture.png');
    lblHeader.SetParentComponent(pnlHeader);
    lblHeader.Name := 'lblHeader';
    lblHeader.Left := 64;
    lblHeader.Top := 16;
    lblHeader.Width := 410;
    lblHeader.Height := 30;
    lblHeader.Alignment := taCenter;
    lblHeader.AutoSize := False;
    lblHeader.Caption := 'Winzeit - WebPortal - Anhangliste';
    lblHeader.Font.Charset := DEFAULT_CHARSET;
    lblHeader.Font.Color := clWindowText;
    lblHeader.Font.Height := -21;
    lblHeader.Font.Name := 'Segoe UI';
    lblHeader.Font.Style := [fsBold];
    lblHeader.HeightPercent := 100.000000000000000000;
    lblHeader.ParentFont := False;
    lblHeader.WidthPercent := 100.000000000000000000;
    btnBack.SetParentComponent(pnlHeader);
    btnBack.Name := 'btnBack';
    btnBack.Left := 16;
    btnBack.Top := 16;
    btnBack.Width := 32;
    btnBack.Height := 32;
    btnBack.HeightPercent := 100.000000000000000000;
    btnBack.WidthPercent := 100.000000000000000000;
    btnBack.ChildOrder := 2;
    SetEvent(btnBack, Self, 'OnClick', 'btnBackClick');
    btnBack.Picture.LoadFromFile('UAttachmentListForm.pnlHeader.btnBack.Picture.png');
    pnlFooter.SetParentComponent(Self);
    pnlFooter.Name := 'pnlFooter';
    pnlFooter.Left := 0;
    pnlFooter.Top := 456;
    pnlFooter.Width := 640;
    pnlFooter.Height := 24;
    pnlFooter.Align := alBottom;
    pnlFooter.Alignment := taLeftJustify;
    pnlFooter.Caption := 'pnlFooter';
    pnlFooter.ChildOrder := 1;
    pnlFooter.Color := clSkyBlue;
    pnlButtons.SetParentComponent(Self);
    pnlButtons.Name := 'pnlButtons';
    pnlButtons.Left := 0;
    pnlButtons.Top := 64;
    pnlButtons.Width := 640;
    pnlButtons.Height := 48;
    pnlButtons.Align := alTop;
    pnlButtons.Caption := 'pnlButtons';
    pnlButtons.ChildOrder := 2;
    pnlButtons.ShowCaption := False;
    lbl.SetParentComponent(pnlButtons);
    lbl.Name := 'lbl';
    lbl.Left := 400;
    lbl.Top := 32;
    lbl.Width := 13;
    lbl.Height := 15;
    lbl.Caption := 'lbl';
    lbl.HeightPercent := 100.000000000000000000;
    lbl.Visible := False;
    lbl.WidthPercent := 100.000000000000000000;
    btnWebCam.SetParentComponent(pnlButtons);
    btnWebCam.Name := 'btnWebCam';
    btnWebCam.Left := 4;
    btnWebCam.Top := 4;
    btnWebCam.Width := 40;
    btnWebCam.Height := 40;
    btnWebCam.Hint := 'Kamera starten';
    btnWebCam.Color := clNone;
    btnWebCam.Glyph.LoadFromFile('UAttachmentListForm.pnlButtons.btnWebCam.Glyph.png');
    btnWebCam.GlyphSize := 32;
    btnWebCam.HeightPercent := 100.000000000000000000;
    btnWebCam.ShowHint := True;
    btnWebCam.WidthPercent := 100.000000000000000000;
    SetEvent(btnWebCam, Self, 'OnClick', 'btnWebCamClick');
    btnFilesystem.SetParentComponent(pnlButtons);
    btnFilesystem.Name := 'btnFilesystem';
    btnFilesystem.Left := 48;
    btnFilesystem.Top := 4;
    btnFilesystem.Width := 40;
    btnFilesystem.Height := 40;
    btnFilesystem.Hint := 'Bild aus Album einf'#252'gen';
    btnFilesystem.Color := clNone;
    btnFilesystem.Glyph.LoadFromFile('UAttachmentListForm.pnlButtons.btnFilesystem.Glyph.png');
    btnFilesystem.GlyphSize := 32;
    btnFilesystem.HeightPercent := 100.000000000000000000;
    btnFilesystem.ShowHint := True;
    btnFilesystem.WidthPercent := 100.000000000000000000;
    SetEvent(btnFilesystem, Self, 'OnClick', 'btnFilesystemClick');
    btnComment.SetParentComponent(pnlButtons);
    btnComment.Name := 'btnComment';
    btnComment.Left := 92;
    btnComment.Top := 4;
    btnComment.Width := 40;
    btnComment.Height := 40;
    btnComment.Hint := 'Kommentar einf'#252'gen';
    btnComment.Color := clNone;
    btnComment.Glyph.LoadFromFile('UAttachmentListForm.pnlButtons.btnComment.Glyph.png');
    btnComment.GlyphSize := 32;
    btnComment.HeightPercent := 100.000000000000000000;
    btnComment.ShowHint := True;
    btnComment.WidthPercent := 100.000000000000000000;
    SetEvent(btnComment, Self, 'OnClick', 'btnCommentClick');
    btnLoad.SetParentComponent(pnlButtons);
    btnLoad.Name := 'btnLoad';
    btnLoad.Left := 580;
    btnLoad.Top := 4;
    btnLoad.Width := 40;
    btnLoad.Height := 40;
    btnLoad.Hint := 'Liste aktualisieren';
    btnLoad.Color := clNone;
    btnLoad.Glyph.LoadFromFile('UAttachmentListForm.pnlButtons.btnLoad.Glyph.png');
    btnLoad.GlyphSize := 32;
    btnLoad.HeightPercent := 100.000000000000000000;
    btnLoad.ShowHint := True;
    btnLoad.WidthPercent := 100.000000000000000000;
    SetEvent(btnLoad, Self, 'OnClick', 'btnLoadClick');
    pnlAttachmentList.SetParentComponent(Self);
    pnlAttachmentList.Name := 'pnlAttachmentList';
    pnlAttachmentList.Left := 0;
    pnlAttachmentList.Top := 167;
    pnlAttachmentList.Width := 640;
    pnlAttachmentList.Height := 289;
    pnlAttachmentList.Align := alClient;
    pnlAttachmentList.Caption := 'pnlAttachmentList';
    pnlAttachmentList.ChildOrder := 3;
    pnlAttachmentList.ShowCaption := False;
    sgAttachmentList.SetParentComponent(pnlAttachmentList);
    sgAttachmentList.Name := 'sgAttachmentList';
    sgAttachmentList.Left := 0;
    sgAttachmentList.Top := 0;
    sgAttachmentList.Width := 640;
    sgAttachmentList.Height := 289;
    sgAttachmentList.Align := alClient;
    sgAttachmentList.TabOrder := 0;
    SetEvent(sgAttachmentList, Self, 'OnDblClick', 'sgAttachmentListDblClick');
    SetEvent(sgAttachmentList, Self, 'OnSelectCell', 'sgAttachmentListSelectCell');
    sgAttachmentList.RangeEdit.Max := 100.000000000000000000;
    sgAttachmentList.RangeEdit.Step := 1.000000000000000000;
    sgAttachmentList.HeightPercent := 100.000000000000000000;
    sgAttachmentList.WordWrap := True;
    sgAttachmentList.WidthPercent := 100.000000000000000000;
    SetEvent(sgAttachmentList, Self, 'OnClickCell', 'sgAttachmentListClickCell');
    btnTake.SetParentComponent(pnlAttachmentList);
    btnTake.Name := 'btnTake';
    btnTake.Left := 580;
    btnTake.Top := 228;
    btnTake.Width := 40;
    btnTake.Height := 40;
    btnTake.Hint := #220'bernehmen';
    btnTake.Color := clNone;
    btnTake.ElementClassName := 'btnMicro';
    btnTake.Glyph.LoadFromFile('UAttachmentListForm.pnlAttachmentList.btnTake.Glyph.png');
    btnTake.GlyphSize := 32;
    btnTake.HeightPercent := 100.000000000000000000;
    btnTake.ShowHint := True;
    btnTake.WidthPercent := 100.000000000000000000;
    SetEvent(btnTake, Self, 'OnClick', 'btnTakeClick');
    pnlSmallButtons.SetParentComponent(Self);
    pnlSmallButtons.Name := 'pnlSmallButtons';
    pnlSmallButtons.Left := 0;
    pnlSmallButtons.Top := 112;
    pnlSmallButtons.Width := 640;
    pnlSmallButtons.Height := 32;
    pnlSmallButtons.Align := alTop;
    pnlSmallButtons.Caption := 'pnlSmallButtons';
    pnlSmallButtons.ChildOrder := 4;
    pnlSmallButtons.ShowCaption := False;
    pnlSmallButtons.Visible := False;
    btnEdit.SetParentComponent(pnlSmallButtons);
    btnEdit.Name := 'btnEdit';
    btnEdit.Left := 32;
    btnEdit.Top := 4;
    btnEdit.Width := 24;
    btnEdit.Height := 24;
    btnEdit.Hint := 'Bearbeiten';
    btnEdit.Color := clNone;
    btnEdit.Glyph.LoadFromFile('UAttachmentListForm.pnlSmallButtons.btnEdit.Glyph.png');
    btnEdit.GlyphSize := 16;
    btnEdit.HeightPercent := 100.000000000000000000;
    btnEdit.ShowHint := True;
    btnEdit.WidthPercent := 100.000000000000000000;
    SetEvent(btnEdit, Self, 'OnClick', 'btnEditClick');
    btnDelete.SetParentComponent(pnlSmallButtons);
    btnDelete.Name := 'btnDelete';
    btnDelete.Left := 4;
    btnDelete.Top := 4;
    btnDelete.Width := 24;
    btnDelete.Height := 24;
    btnDelete.Hint := 'L'#246'schen';
    btnDelete.Color := clNone;
    btnDelete.Glyph.LoadFromFile('UAttachmentListForm.pnlSmallButtons.btnDelete.Glyph.png');
    btnDelete.GlyphSize := 16;
    btnDelete.HeightPercent := 100.000000000000000000;
    btnDelete.ShowHint := True;
    btnDelete.WidthPercent := 100.000000000000000000;
    SetEvent(btnDelete, Self, 'OnClick', 'btnDeleteClick');
    pnlInfo.SetParentComponent(Self);
    pnlInfo.Name := 'pnlInfo';
    pnlInfo.Left := 0;
    pnlInfo.Top := 144;
    pnlInfo.Width := 640;
    pnlInfo.Height := 23;
    pnlInfo.Align := alTop;
    pnlInfo.Caption := 'pnlInfo';
    pnlInfo.ChildOrder := 5;
    pnlInfo.ShowCaption := False;
    lblInfo.SetParentComponent(pnlInfo);
    lblInfo.Name := 'lblInfo';
    lblInfo.Left := 8;
    lblInfo.Top := 4;
    lblInfo.Width := 34;
    lblInfo.Height := 15;
    lblInfo.Caption := 'lblInfo';
    lblInfo.HeightPercent := 100.000000000000000000;
    lblInfo.WidthPercent := 100.000000000000000000;
  finally
    pnlHeader.AfterLoadDFMValues;
    imgLogo.AfterLoadDFMValues;
    lblHeader.AfterLoadDFMValues;
    btnBack.AfterLoadDFMValues;
    pnlFooter.AfterLoadDFMValues;
    pnlButtons.AfterLoadDFMValues;
    lbl.AfterLoadDFMValues;
    btnWebCam.AfterLoadDFMValues;
    btnFilesystem.AfterLoadDFMValues;
    btnComment.AfterLoadDFMValues;
    btnLoad.AfterLoadDFMValues;
    pnlAttachmentList.AfterLoadDFMValues;
    sgAttachmentList.AfterLoadDFMValues;
    btnTake.AfterLoadDFMValues;
    pnlSmallButtons.AfterLoadDFMValues;
    btnEdit.AfterLoadDFMValues;
    btnDelete.AfterLoadDFMValues;
    pnlInfo.AfterLoadDFMValues;
    lblInfo.AfterLoadDFMValues;
  end;
end;

end.
